<template>
  <div>
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"
    >
      Компании
    </div>
    <v-chip-group
      v-model="selection"
      active-class="primary accent-4 white--text"
      column
    >
      <v-chip @click="switchActiveOrArchive" color="white">
        <v-icon>mdi-check</v-icon> Активные
      </v-chip>
      <v-chip @click="switchActiveOrArchive" color="white">
        <v-icon>mdi-archive</v-icon> Архивные
      </v-chip>
    </v-chip-group>
    <object-grid-advanced
      :value="
        this.companies.map((company) => ({
          ...company,
          trial_end_time: company.trial_end_time
            ? new Date(company.trial_end_time).toLocaleDateString('id-BN')
            : '',
          // Пробный период — вычисляемое поле, в БД не хранится (п.18).
          trial_parsed:
            company.trial_end_time &&
            new Date() <= new Date(company.trial_end_time)
              ? 'Да'
              : 'Нет',
        }))
      "
      :field-defs="[
        { text: 'Компания', value: 'name', width: '10%' },
        { text: 'ИНН', value: 'inn', width: '10%' },
        { text: 'ОГРН', value: 'ogrn', width: '10%' },
        { text: 'Пробный период', value: 'trial_parsed', width: '10%' },
        { text: 'Баланс', value: 'balance', width: '10%' },
        {
          text: 'Конец пробного периода',
          value: 'trial_end_time',
          width: '10%',
        },
        { text: 'E-mail', value: 'email', width: '10%' },
        { text: 'Телефон', value: 'phone', width: '10%' },
      ]"
      :show-actions="{
        edit: true,
      }"
      @doEditItem="editCompany"
      instance-id="manager_companySearch"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ObjectGridAdvanced from "@/components/ObjectGridAdvanced.vue";
import moment from "moment";
import "moment/locale/ru";
import CompanyForm from "@/components/CompanyForm.vue";

export default {
  name: "ManagerCompaniesView",
  components: { ObjectGridAdvanced },
  computed: {
    ...mapGetters("companies", ["companies"]),
    ...mapGetters("users", ["users"]),
  },
  data: () => ({
    selection: 0,
  }),
  methods: {
    ...mapActions("companies", ["request_companies", "update_company"]),
    ...mapActions("users", ["request_users"]),
    ...mapActions("modals", ["showModalForm"]),
    switchActiveOrArchive() {
      // check on next tick
      this.$nextTick(() => {
        this.request_companies(this.selection ? "archive=1" : "");
      });
    },
    editCompany(company) {
      this.showModalForm({
        component: CompanyForm,
        title: `Компания ${company.id}`,
        desc: ``,
        value: {
          id: company.id,
          max_courses_trial: company.max_courses_trial,
          price_modifier: company.price_modifier,
        },
        managers: this.managers,
      }).then((payload) => {
        // Менеджеру доступны только эти два поля формы.
        let { id, max_courses_trial, price_modifier } = payload;

        let updatedCompany = {
          id,
          max_courses_trial,
          price_modifier,
        };

        this.update_company(updatedCompany).then(() => {
          this.request_companies();
        });
      });
    },
  },
  beforeMount() {
    this.request_companies();
    this.request_users();
  },
  mounted() {
    moment.locale("ru");
  },
};
</script>

<style scoped lang="scss"></style>
